export const CFBaseIconVariant = {
    FILLED: 'filled',
    OUTLINED: 'outlined',
};
//
// NOTE: Due to differences between React and ReactNative, we buffer the SVG output through this function.
// For ReactWeb, we allow standard SVG tags as default values here.
// But for React Native, a set of appropriate elements will need to be provided through the `components` property.
// We expect a library such as `react-native-svg` to be used.
//
export const CFBaseIconSVGElements = (elements) => {
    return {
        Circle: (elements === null || elements === void 0 ? void 0 : elements.Circle) || 'circle',
        G: (elements === null || elements === void 0 ? void 0 : elements.G) || 'g',
        Path: (elements === null || elements === void 0 ? void 0 : elements.Path) || 'path',
        Rect: (elements === null || elements === void 0 ? void 0 : elements.Rect) || 'rect',
        Svg: (elements === null || elements === void 0 ? void 0 : elements.Svg) || 'svg',
        // Add other SVG Elements to buffer here as needed
    };
};
//
// Retrieves a specific SVG icon definition
//
// Note that in a React Native context the `components` property should be passed
// in order to provide the necessary local components used to render SVG content.
// We expect a library such as `react-native-svg` to be used.
export const getCFBaseIcon = (iconSet, icon) => {
    return iconSet.find(({ alias }) => alias === icon) || null;
};
